export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_TAB = 'SET_TAB';
export const SET_SUBTAB = 'SET_SUBTAB';
export const SET_START_INFO_LOADED = 'SET_START_INFO_LOADED';
export const SET_TAB_CATEGORY = 'SET_TAB_CATEGORY';
export const SET_IS_FIRST_LOAD_START_INFO = 'SET_IS_FIRST_LOAD_START_INFO';
export const SET_IS_NEED_PRELOAD = 'SET_IS_NEED_PRELOAD';
